<template>
	<div class="h-full">
		<div class="w-full mb-5 flex justify-between">
			<h1 class="text-3xl font-black text-dbBlue">
				Licensing
			</h1>
		</div>
		<div class="grid grid-cols-2 gap-4 sm:gap-6 lg:gap-8">
			<div class="card col-span-2">
				<div class="flex flex-wrap items-center justify-between sm:flex-nowrap px-4 py-5 sm:px-6 bg-white relative overflow-hidden">
					<div>
						<h2 class="card-heading">
							All Licenses
						</h2>
					</div>
					<card-header-backdrop class="opacity-20" />
				</div>
				<div class="px-4 py-5 sm:p-6">
					<tw-table
						:data="licenses"
						:loading="loading"
						placeholder="No Licenses">
						<tw-table-column
							condensed
							header="Contract #" 
							prop="productNumber"
							class-name="font-bold text-gray-900" />
						<tw-table-column
							condensed
							header="Expiration Date"
							prop="expirationDate" />
						<tw-table-column
							condensed
							class-name="hidden sm:table-cell"
							header-class-name="hidden sm:table-cell"
							header="Term Years" 
							prop="termYears" />
						<tw-table-column
							header="Subtotal"
							condensed
							header-class-name="text-right"
							class-name="text-right">
							<template #default="{row}">
								{{ currencyFormatter.format(row.subtotal) }}
							</template>
						</tw-table-column>
						<tw-table-column
							condensed
							header="Download" 
							header-class-name="sr-only"
							class-name="text-right">
							<template #default="{row}">
								<a
									v-if="row.key"
									class="link"
									:href="'https://accounts.claris.com/software/license/' + row.key"
									target="_blank">
									<span class="hidden sm:block">Download</span><ArrowDownTrayIconMini class="w-5 h-5 sm:hidden" />
								</a>
							</template>
						</tw-table-column>
					</tw-table>
				</div>
			</div>
		</div>
	</div>
</template>

<script lang="ts">
	export default { name: 'LicensingMain' } // name the component
</script>

<script setup lang="ts">
	// api
	import {
		fetchLicenses
	} from './queries'

	// components
	import {
		ArrowDownTrayIcon as ArrowDownTrayIconMini
	} from "@heroicons/vue/20/solid"

	// vue
	import {
		ref,
		onMounted
	} from "vue"

	const loading = ref(true)
	const licenses = ref<any>([])

	const currencyFormatter = new Intl.NumberFormat("en-US", {
		style: "currency",
		currency: "USD",
	})

	onMounted(() => {
		getLicenses()
	})

	async function getLicenses() {
		try {
			loading.value = true
			licenses.value = await fetchLicenses()
		}
		catch(e) {
			console.error(e)
		}
		finally {
			loading.value = false
		}
	}
</script>
